<style scoped="scoped" lang="scss"></style>

<template>
	<div style="display: inline;">
		<!-- table表格 -->
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/andon/record/listByPage"
			getKey="rows" :columns="columns">
			<!-- 搜索框插槽 -->
			<template #conditions>
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('shebeimingcheng')">
						<yi_cross_select multiple :component="'web_base_equipment_list'"
							:ids.sync="yt.conditions.equipments">
						</yi_cross_select>
					</el-form-item>
					<el-form-item :label="$t('yichangleixingmingcheng')">
						<el-select multiple filterable :clearable="true" v-model="yt.conditions.exceptionTypes">
							<el-option v-for="(item, index) in exceptionTypeList" :key="index" :label="item.name"
								:value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary"
							plain="plain" :loading="yt.loading">
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear({orderBy: 'createTime desc,triggerTime asc'})" :loading="yt.loading">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('dianjianxiang', scope.row,'70%')">
							{{$t('dianjianxiang')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button v-if="scope.row.status==1" type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/equipment/check/bill/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>
		</yi_curd_table>
		<el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
			:width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
			<!-- 点检项 -->
			<template v-if="yt.editObj.action == 'dianjianxiang'">
				<div class="dialog-scroller">
					<check_item :equipment="yt.editObj" ref="checkItem"></check_item>
				</div>

				<span slot="footer" class="dialog-footer">
					<el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini"
						@click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button v-if="!(yt.editObj.status == 3 || yt.editObj.status == 2)" size="mini"
						@click="submitCheckItem(yt.editObj)" type="primary">
						{{$t('tijiao')}}
					</el-button>
				</span>
			</template>
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'web_andon_management_records_list',
		data() {
			return {
				exceptionTypeList: [],
				columns: [ {
						label: 'shebeimingcheng',
						prop: 'equipment.name',
					}, {
						label: 'yichangleixingmingcheng',
						prop: 'exceptionType.name',
						width: 130,
					}, {
						label: 'erjiyichangleixingmingcheng',
						prop: 'levelSecondExceptionType.name',
						width: 180,
					}, {
						label: 'zhuangtai',
						type: 'tag',
						prop: 'status',
						tags: {
							0: {
								color: '#E6A23C',
								text: this.$t('daiqueren')
							},
							1: {
								color: '#F56C6C',
								text: this.$t('daichuli')
							},
							2: {
								color: '#67C23A',
								text: this.$t('yichuli')
							}
						},
					}, {
						label: 'yichangchufashijian',
						prop: 'triggerTime',
						type: 'time',
						width: 130,
						// format: 'yyyy-MM-dd:hh:mm:ss'
					},
					{
						label: 'chufaren',
						prop: 'triggerUser.nickname',
						width: 130,
					},
					{
						label: 'yichangmiaoshu',
						prop: 'description',
						width: 130,
					},
					{
						label: 'yichangquerenshijian',
						prop: 'confirmTime',
						type: 'time',
						width: 130,
						// format: 'yyyy-MM-dd:hh:mm:ss'
					},
					{
						label: 'yichangjiechushijian',
						prop: 'triggerTime',
						type: 'time',
						width: 130,
						// format: 'yyyy-MM-dd:hh:mm:ss'
					},
					{
						label: 'jiejueren',
						prop: 'solverObject.nickname',
						width: 130,
					},
					{
						label: 'jiejuecuoshi',
						prop: 'solution',
						width: 130,
					},
				]
			};
		},
		created() {
			setTimeout(() => {
				this.yt.conditions = {
					orderBy: 'createTime desc,triggerTime asc',
				}
				this.yt.get(1);
				this.getExceptionType()
			}, 300)
		},

		methods: {
			submitCheckItem(value) {
				this.http.post('web/equipment/check/bill/commit', {
					id: value.id,
					remark: value.remark,
					itemList: this.$refs.checkItem.$refs.yt.list
				}).then(res => {
					this.yt.isShowEditDialog = false
					this.yt.get(1)
				});
			},
			getExceptionType() {
				this.http.get('/web/andon/exceptionType/page', {
					params: {
						pageNum: 1,
						pageSize: 1000
					}
				}).then(res => {
					this.exceptionTypeList = res.data.rows
				})
			
			}
		}
	};
</script>
